import { render, staticRenderFns } from "./Prospects.vue?vue&type=template&id=3cea6e88&scoped=true"
import script from "./Prospects.vue?vue&type=script&lang=js"
export * from "./Prospects.vue?vue&type=script&lang=js"
import style0 from "./Prospects.vue?vue&type=style&index=0&id=3cea6e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cea6e88",
  null
  
)

export default component.exports